import { useQuery } from "@tanstack/react-query"
import { searchSuppliers, type CompanyFilters, type ProductFilters } from "@/lib/api/search.api"
import { useAuthStore } from "@/store/auth.store"

export function useSearchSuppliers(query: string, companyFilters?: CompanyFilters, productFilters?: ProductFilters) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["search-suppliers", query, companyFilters, productFilters],
    queryFn: () => {
      // const now = new Date()
      // console.log(`[API HIT - searchSuppliers] Query: "${query}" | Timestamp: ${now.toISOString()} (${now.toLocaleTimeString()})`)
      return searchSuppliers(query, accessToken ?? undefined, companyFilters, productFilters)
    },
    enabled: !!query,
    staleTime: 5 * 60 * 1000, // 5 minutes cache to prevent refetch on remount
    refetchOnWindowFocus: false,
  })
}